<ion-button class="btn-1" [ngClass]="!isNoHeght ? 'h-52':''" expand="block" mode="ios" (click)="onButtonClick()">
  <ion-text [ngClass]="[fontFamily, fontSize]">
    {{title | getLanguagePipe}}
  </ion-text>
  <ion-icon *ngIf="!isNoIcon" slot="end" size="large" class="ml-12" [src]="'ic_login' | getImagePipe"></ion-icon>
</ion-button>